import React, { useState, createContext, useContext } from 'react';
import { AskModal } from './components/ask-modal';

import { ConfirmModal } from './components/confirm-modal';
import { ConnectCrmModal } from './components/connect-crm-modal';
import { DisconnectCrmModal } from './components/disconnect-crm-modal';
import { FailModal } from './components/fail-modal';
import { InviteModal } from './components/invite-modal';
import { SuccessModal } from './components/success-modal';

export const MODAL_TYPES = {
	SUCCESS_MODAL: 'SUCCESS_MODAL',
	FAIL_MODAL: 'FAIL_MODAL',
	CONFIRM_MODAL: 'CONFIRM_MODAL',
	CONNECT_CRM: 'CONNECT_CRM',
	DISCONNECT_CRM: 'DISCONNECT_CRM',
	ASK_MODAL: 'ASK_MODAL',
	INVITE_MODAL: 'INVITE_MODAL',
};

const MODAL_COMPONENTS: any = {
	[MODAL_TYPES.SUCCESS_MODAL]: SuccessModal,
	[MODAL_TYPES.FAIL_MODAL]: FailModal,
	[MODAL_TYPES.CONFIRM_MODAL]: ConfirmModal,
	[MODAL_TYPES.CONNECT_CRM]: ConnectCrmModal,
	[MODAL_TYPES.DISCONNECT_CRM]: DisconnectCrmModal,
	[MODAL_TYPES.ASK_MODAL]: AskModal,
	[MODAL_TYPES.INVITE_MODAL]: InviteModal,
};

type GlobalModalContextModel = {
	showModal: (modalType: string, modalProps?: any) => void;
	hideModal: () => void;
	store: any;
};

const initalState: GlobalModalContextModel = {
	showModal: () => {},
	hideModal: () => {},
	store: {},
};

const GlobalModalContext = createContext(initalState);
export const useGlobalModalContext = () => useContext(GlobalModalContext);

export const GlobalModal: React.FC<{}> = ({ children }) => {
	const [store, setStore] = useState<any>();
	const { modalType, modalProps } = store || {};

	const showModal = (modalType: string, modalProps: any = {}) => {
		setStore({
			...store,
			modalType,
			modalProps,
		});
	};

	const hideModal = () => {
		setStore({
			...store,
			modalType: null,
			modalProps: {},
		});
	};

	const renderComponent = () => {
		const ModalComponent = MODAL_COMPONENTS[modalType];
		if (!modalType || !ModalComponent) {
			return null;
		}
		return <ModalComponent id="global-modal" {...modalProps} />;
	};

	return (
		<GlobalModalContext.Provider value={{ store, showModal, hideModal }}>
			{renderComponent()}
			{children}
		</GlobalModalContext.Provider>
	);
};
